var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-cell',{staticClass:"weight",class:{'is-summary': _vm.summary},attrs:{"type":"stat","format":_vm.format}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }